import Section from "../../../components/section/section";
import NoAppointmentsMessage from "./src/noAppointmentsMessage";
import CancellationText from "./src/cancellationText";
import BookedAppointmentTile from "./src/bookedAppointmentTile";
import React from "react";
import { Appointment } from "../../../context/appContext";
import { AppointmentsParticipantContext } from "./context/appointmentsParticipantContext";
import RateAppointmentDialog from "./src/rateAppointmentDialog";

const AppointmentsParticipantContainer = (): React.JSX.Element => {
  const {
    myAppointments,
  }: {
    myAppointments: Appointment[];
  } = React.useContext(AppointmentsParticipantContext);

  return (
    <Section>
      {myAppointments.length === 0 ? (
        <NoAppointmentsMessage />
      ) : (
        <React.Fragment>
          <CancellationText />

          {myAppointments.map((appointment: Appointment) => (
            <BookedAppointmentTile
              key={appointment.id}
              appointment={appointment}
            />
          ))}
        </React.Fragment>
      )}

      <RateAppointmentDialog />
    </Section>
  );
};

export default AppointmentsParticipantContainer;
